import { useState } from 'react';

interface IInfoFieldProps {
    label: string;
    value: string | string[];
    hidable?: boolean;
    isOneLine?: boolean;
    moreThanOneItem?: boolean;
}

const InfoField = ({ label, value, hidable, isOneLine = false, moreThanOneItem = false }: IInfoFieldProps) => {
    const [isHidden, setIsHidden] = useState(true);

    return (
        <div className="info-field">
            <p className="info-field__label">{label}</p>
            {moreThanOneItem ? (
                Array.isArray(value) &&
                value.map((item, index) => (
                    <div key={index + item} className="info-field__value-wrapper">
                        <p className="info-field__value">{item}</p>
                    </div>
                ))
            ) : (
                <div className="info-field__value-wrapper">
                    <p className="info-field__value" style={isOneLine ? { whiteSpace: 'nowrap', wordBreak: 'keep-all' } : undefined}>
                        {hidable && isHidden ? '****' : value}
                    </p>
                    {hidable && <img onClick={() => setIsHidden(prev => !prev)} src={isHidden ? '/svg/eye.svg' : '/svg/eye-slash.svg'} alt="Eye" />}
                </div>
            )}
        </div>
    );
};

export default InfoField;
